<template>
  <section>
    <ul class="image-list">
      <li
        class="img-area"
        v-for="(item, index) in selectedSpot.spot_images"
        :key="index"
        @click="onClickImg(item.image_url)"
      >
        <img class="img" :src="item.image_url" />
      </li>
    </ul>

    <div class="background" v-if="selectedImgPath" @click="onCloseImg">
      <div class="closeButton" @click="onCloseImg">
        <img class="closeButtonInner" src="@/assets/close.svg" />
      </div>
      <div class="dialog" v-show="selectedImgPath">
        <img v-show="selectedImgPath" :src="selectedImgPath" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "image-area",
  components: {},
  props: {
    selectedSpot: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      selectedImgPath: undefined,
    };
  },
  methods: {
    onClickImg(imagePath) {
      this.selectedImgPath = imagePath;
    },
    onCloseImg() {
      this.selectedImgPath = undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.image-list {
  padding: 0.25rem 1.25rem;
  display: flex;
  overflow: scroll;
  gap: 1rem;
  .img-area {
    align-items: center;
    display: flex;

    .img {
      width: 7rem;
      height: 6rem;
      object-fit: contain;
    }
  }
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 1000;
  transform: translateZ(1000);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -2rem;
}
.closeButton {
  font-size: 2rem;
  margin-bottom: 1rem;
  .closeButtonInner {
    width: 1rem;
  }
}
.dialog {
  background-color: transparent;
  z-index: 1001;
  width: calc(100% - 1rem * 2);
  max-height: 75%;
  overflow: scroll;
  position: relative;
  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelectModal/ImageArea.vue